import { localizeWithPath, localize2WithPath } from 'vscode/vscode/vs/nls';

const _moduleId = "vs/workbench/contrib/terminal/common/terminalStrings";
const terminalStrings = {
    terminal: ( localizeWithPath(_moduleId, 0, "Terminal")),
    new: ( localizeWithPath(_moduleId, 1, "New Terminal")),
    doNotShowAgain: ( localizeWithPath(_moduleId, 2, 'Do Not Show Again')),
    currentSessionCategory: ( localizeWithPath(_moduleId, 3, 'current session')),
    previousSessionCategory: ( localizeWithPath(_moduleId, 4, 'previous session')),
    typeTask: ( localizeWithPath(_moduleId, 5, "Task")),
    typeLocal: ( localizeWithPath(_moduleId, 6, "Local")),
    actionCategory: ( localize2WithPath(_moduleId, 7, "Terminal")),
    focus: ( localize2WithPath(_moduleId, 8, "Focus Terminal")),
    focusAndHideAccessibleBuffer: ( localize2WithPath(_moduleId, 9, "Focus Terminal and Hide Accessible Buffer")),
    kill: {
        ...( localize2WithPath(_moduleId, 10, "Kill Terminal")),
        short: ( localizeWithPath(_moduleId, 11, "Kill")),
    },
    moveToEditor: ( localize2WithPath(_moduleId, 12, "Move Terminal into Editor Area")),
    moveIntoNewWindow: ( localize2WithPath(_moduleId, 13, "Move Terminal into New Window")),
    moveToTerminalPanel: ( localize2WithPath(_moduleId, 14, "Move Terminal into Panel")),
    changeIcon: ( localize2WithPath(_moduleId, 15, "Change Icon...")),
    changeColor: ( localize2WithPath(_moduleId, 16, "Change Color...")),
    split: {
        ...( localize2WithPath(_moduleId, 17, "Split Terminal")),
        short: ( localizeWithPath(_moduleId, 18, "Split")),
    },
    unsplit: ( localize2WithPath(_moduleId, 19, "Unsplit Terminal")),
    rename: ( localize2WithPath(_moduleId, 20, "Rename...")),
    toggleSizeToContentWidth: ( localize2WithPath(_moduleId, 21, "Toggle Size to Content Width")),
    focusHover: ( localize2WithPath(_moduleId, 22, "Focus Hover")),
    sendSequence: ( localize2WithPath(_moduleId, 23, "Send Custom Sequence To Terminal")),
    newWithCwd: ( localize2WithPath(
        _moduleId,
        24,
        "Create New Terminal Starting in a Custom Working Directory"
    )),
    renameWithArgs: ( localize2WithPath(_moduleId, 25, "Rename the Currently Active Terminal")),
    stickyScroll: ( localize2WithPath(_moduleId, 26, "Sticky Scroll")),
    scrollToPreviousCommand: ( localize2WithPath(_moduleId, 27, "Scroll To Previous Command")),
    scrollToNextCommand: ( localize2WithPath(_moduleId, 28, "Scroll To Next Command"))
};

export { terminalStrings };
